import { isPure1Production } from '../utils/url';
import { LazyLoadingScriptService } from './lazy-load-scripts.service';

// Public keys — restricted in GCP by HTTP-referrer to their respective hostnames.
const PROD_API_KEY = 'AIzaSyBefyJ4f2jpCK7v5igtPxhZxafzRK-TM9M';
const STAGING_API_KEY = 'AIzaSyAp3TqvD1qioFr71Uwmz0iuUWrtwi2L-w4';

export const googleMapsPromiseFactory = (lazyLoadScript: LazyLoadingScriptService): Promise<typeof google.maps> => {
    // The same bundle deploys to staging and prod, so pick the key at runtime by hostname.
    const key = isPure1Production() ? PROD_API_KEY : STAGING_API_KEY;
    return new Promise((accept, reject) => {
        lazyLoadScript
            .loadScript(`https://maps.googleapis.com/maps/api/js?libraries=places,geometry&key=${key}`)
            .subscribe(
                (progress: number) => {
                    if (progress === 1) {
                        accept(google.maps);
                    }
                },
                (err: string) => reject(err),
            );
    });
};
